import { School, UserRound } from 'lucide-react';
import type { PillField } from '@/components/common/LabeledPill';
import { OPTION_DETAIL_SEPARATOR } from '@/utils/filters';
import type { MonitorDetailRow } from '../types/question.types';

const AREA_SEPARATOR = ', ';

const joinPresent = (parts: (string | null)[], separator: string): string | undefined =>
  parts.filter((part) => part !== null && part !== '').join(separator) || undefined;

export function getHolderPills(
  holder: MonitorDetailRow | undefined,
  isLoading: boolean,
): PillField[] {
  if (holder === undefined) {
    return [
      { key: 'institution', icon: School, label: 'Institution', value: undefined, isLoading },
      { key: 'member', icon: UserRound, label: 'ZM', value: undefined, isLoading },
    ];
  }

  const instituteCode = holder.instituteCode === null ? null : String(holder.instituteCode);
  return [
    {
      key: 'institution',
      icon: School,
      label: 'Institution',
      value: joinPresent([holder.instituteName, instituteCode], OPTION_DETAIL_SEPARATOR),
      hint: joinPresent(
        [holder.divisionName, holder.districtName, holder.thanaName],
        AREA_SEPARATOR,
      ),
      isLoading,
    },
    {
      key: 'member',
      icon: UserRound,
      label: 'ZM',
      value: holder.userName ?? undefined,
      hint: joinPresent(
        [
          holder.userMobile,
          holder.userDesignation,
          holder.userHrEmpId === null ? null : `HR ID ${holder.userHrEmpId}`,
          joinPresent(
            [holder.userDivisionName, holder.userDistrictName, holder.userThanaName],
            AREA_SEPARATOR,
          ) ?? null,
        ],
        OPTION_DETAIL_SEPARATOR,
      ),
      isLoading,
    },
  ];
}
